import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = ["id", "mounted"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxFilterPanel = _resolveComponent("DxFilterPanel")!
  const _component_DxFilterBuilderPopup = _resolveComponent("DxFilterBuilderPopup")!
  const _component_DxGroupPanel = _resolveComponent("DxGroupPanel")!
  const _component_DxGrouping = _resolveComponent("DxGrouping")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxStateStoring = _resolveComponent("DxStateStoring")!
  const _component_DxExport = _resolveComponent("DxExport")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_CatalogueSelectControl = _resolveComponent("CatalogueSelectControl")!
  const _component_DateControl = _resolveComponent("DateControl")!
  const _component_EnumControl = _resolveComponent("EnumControl")!
  const _component_DecimalControl = _resolveComponent("DecimalControl")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_CheckBoxControl = _resolveComponent("CheckBoxControl")!
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_DxMasterDetail = _resolveComponent("DxMasterDetail")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DataFillDialog = _resolveComponent("DataFillDialog")!
  const _component_ImportWorkflow = _resolveComponent("ImportWorkflow")!
  const _component_ExportWorkflow = _resolveComponent("ExportWorkflow")!
  const _component_CopyWorkflow = _resolveComponent("CopyWorkflow")!

  return (_openBlock(), _createElementBlock("div", {
    onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetSelectedRows && _ctx.resetSelectedRows(...args))),
    tabindex: "0",
    ref: "area"
  }, [
    _createVNode(_component_DxDataGrid, {
      summary: _ctx.summaryConfig,
      key: _ctx.dxGridRenderKey,
      ref: _ctx.refTable,
      selection: _ctx.selectionConfig,
      "data-source": _ctx.dataSource,
      "show-borders": true,
      "row-alternation-enabled": true,
      "show-column-lines": true,
      "show-row-lines": false,
      "column-min-width": 50,
      "column-auto-width": _ctx.designConfig.horizontalScroll,
      "allow-column-resizing": true,
      "allow-column-reordering": _ctx.editingConfig.allowColumnReordering,
      "remote-operations": _ctx.remoteOperations,
      "filter-builder": _ctx.filterBuilder,
      "filter-value": _ctx.filterValue,
      "word-wrap-enabled": true,
      onToolbarPreparing: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onToolbarPreparing($event))),
      onRowDblClick: _ctx.onRowDblClick,
      onContentReady: _ctx.onContentReady,
      onRowClick: _ctx.onRowClick,
      onInitNewRow: _ctx.onInitNewRow,
      onRowUpdating: _ctx.onRowUpdating,
      onRowUpdated: _ctx.onRowUpdated,
      onRowInserting: _ctx.onRowInserting,
      onRowInserted: _ctx.onRowInserted,
      onRowRemoved: _ctx.onRowRemoved,
      onRowPrepared: _ctx.onRowPrepared,
      onEditingStart: _ctx.onEditingStart,
      onEditCanceling: _ctx.onEditCanceling,
      onSaving: _ctx.saving,
      onOptionChanged: _ctx.onOptionChanged,
      onRowValidating: _ctx.onRowValidating,
      onEditorPreparing: _ctx.onEditorPreparing,
      onExporting: _ctx.onExporting,
      onCellPrepared: _ctx.onCellPrepared,
      "hover-state-enabled": _ctx.selectionConfig.hoverStateEnabled,
      width: _ctx.designConfig.width,
      height: 
        _ctx.designConfig.pagingMode == 'paging'
          ? _ctx.designConfig.height
          : _ctx.designConfig.heightScroll
      ,
      columnMinWidth: _ctx.designConfig.columnMinWidth,
      onRowExpanding: _ctx.onRowExpanding,
      onSelectionChanged: _ctx.onSelectionChanged
    }, {
      catalogueTemplate: _withCtx(({ data: cellInfo }) => [
        _createVNode(_component_CatalogueSelectControl, {
          onChanged: ($event: any) => (_ctx.onCatalogueTemplateValueChanged($event, cellInfo)),
          id: 
            cellInfo.data[_ctx.getColumnData(cellInfo.column.dataField).modelIdField]
          ,
          desc: 
            cellInfo.data[
              _ctx.getColumnData(cellInfo.column.dataField).modelDescField
            ]
          ,
          keyField: _ctx.getColumnData(cellInfo.column.dataField).keyField,
          displayDescField: 
            _ctx.getColumnData(cellInfo.column.dataField).displayDescField
          ,
          catalogueComponentName: 
            _ctx.getColumnData(cellInfo.column.dataField).catalogueComponentName
          ,
          hasEmptyValue: _ctx.getColumnData(cellInfo.column.dataField).allowEmpty,
          filters: _ctx.catalogueSelectControlFilters
        }, null, 8, ["onChanged", "id", "desc", "keyField", "displayDescField", "catalogueComponentName", "hasEmptyValue", "filters"])
      ]),
      dateTimeTemplate: _withCtx(({ data: cellInfo }) => [
        _createVNode(_component_DateControl, {
          value: _ctx.getCellValue(cellInfo),
          onChanged: ($event: any) => (_ctx.onTemplateValueChanged($event, cellInfo)),
          key: _ctx.forceKeys[cellInfo.column.dataField],
          hasEmptyValue: _ctx.getColumnData(cellInfo.column.dataField).allowEmpty,
          mode: _ctx.getColumnData(cellInfo.column.dataField).mode
        }, null, 8, ["value", "onChanged", "hasEmptyValue", "mode"])
      ]),
      enumTemplate: _withCtx(({ data: cellInfo }) => [
        _createVNode(_component_EnumControl, {
          id: 
            cellInfo.data[_ctx.getColumnData(cellInfo.column.dataField).modelField]
          ,
          desc: 
            cellInfo.data[
              _ctx.getColumnData(cellInfo.column.dataField).modelDescField
            ]
          ,
          onChanged: ($event: any) => (_ctx.onEnumTemplateValueChanged($event, cellInfo)),
          enumType: _ctx.getColumnData(cellInfo.column.dataField).enumType,
          hasEmptyValue: _ctx.getColumnData(cellInfo.column.dataField).allowEmpty
        }, null, 8, ["id", "desc", "onChanged", "enumType", "hasEmptyValue"])
      ]),
      decimalTemplate: _withCtx(({ data: cellInfo }) => [
        _createVNode(_component_DecimalControl, {
          value: _ctx.getCellValue(cellInfo),
          onChanged: ($event: any) => (_ctx.onTemplateValueChanged($event, cellInfo)),
          key: _ctx.forceKeys[cellInfo.column.dataField],
          hasEmptyValue: _ctx.getColumnData(cellInfo.column.dataField).allowEmpty,
          decimalPoints: 
            _ctx.getColumnData(cellInfo.column.dataField).decimalPoints
          ,
          step: _ctx.getColumnData(cellInfo.column.dataField).step,
          min: _ctx.getColumnData(cellInfo.column.dataField).min,
          max: _ctx.getColumnData(cellInfo.column.dataField).max
        }, null, 8, ["value", "onChanged", "hasEmptyValue", "decimalPoints", "step", "min", "max"])
      ]),
      integerTemplate: _withCtx(({ data: cellInfo }) => [
        _createVNode(_component_IntegerControl, {
          value: _ctx.getCellValue(cellInfo),
          onChanged: ($event: any) => (_ctx.onTemplateValueChanged($event, cellInfo)),
          key: _ctx.forceKeys[cellInfo.column.dataField],
          hasEmptyValue: _ctx.getColumnData(cellInfo.column.dataField).allowEmpty,
          min: _ctx.getColumnData(cellInfo.column.dataField).min,
          max: _ctx.getColumnData(cellInfo.column.dataField).max
        }, null, 8, ["value", "onChanged", "hasEmptyValue", "min", "max"])
      ]),
      booleanTemplate: _withCtx(({ data: cellInfo }) => [
        _createVNode(_component_CheckBoxControl, {
          value: _ctx.getCellValue(cellInfo),
          onChanged: ($event: any) => (_ctx.onTemplateValueChanged($event, cellInfo)),
          key: _ctx.forceKeys[cellInfo.column.dataField],
          disabled: 
            this.editedRow == cellInfo.data.id || cellInfo.data.id == null
              ? _ctx.getColumnDisabled(cellInfo)
              : true
          
        }, null, 8, ["value", "onChanged", "disabled"])
      ]),
      textBooleanDateTimeTemplate: _withCtx(({ data: cellInfo }) => [
        (
            cellInfo.data[
              _ctx.getColumnData(cellInfo.column.dataField).dataFieldBoolean
            ] != null
          )
          ? (_openBlock(), _createBlock(_component_CheckBoxControl, {
              value: 
            cellInfo.data[
              _ctx.getColumnData(cellInfo.column.dataField).dataFieldBoolean
            ]
          ,
              onChanged: ($event: any) => (_ctx.onTemplateValueChanged($event, cellInfo)),
              key: _ctx.forceKeys[cellInfo.column.dataField],
              disabled: _ctx.getColumnDisabled(cellInfo)
            }, null, 8, ["value", "onChanged", "disabled"]))
          : (
            cellInfo.data[
              _ctx.getColumnData(cellInfo.column.dataField).dataFieldDateTime
            ] != null
          )
            ? (_openBlock(), _createBlock(_component_DateControl, {
                value: 
            cellInfo.data[
              _ctx.getColumnData(cellInfo.column.dataField).dataFieldDateTime
            ]
          ,
                onChanged: ($event: any) => (_ctx.onTemplateValueChanged($event, cellInfo)),
                key: _ctx.forceKeys[cellInfo.column.dataField],
                hasEmptyValue: _ctx.getColumnData(cellInfo.column.dataField).allowEmpty,
                mode: "datetime",
                readOnly: true
              }, null, 8, ["value", "onChanged", "hasEmptyValue"]))
            : (_openBlock(), _createBlock(_component_TextControl, {
                value: _ctx.getCellValue(cellInfo),
                onChanged: ($event: any) => (_ctx.onTemplateValueChanged($event, cellInfo)),
                key: _ctx.forceKeys[cellInfo.column.dataField],
                hasEmptyValue: _ctx.getColumnData(cellInfo.column.dataField).allowEmpty,
                readOnly: true
              }, null, 8, ["value", "onChanged", "hasEmptyValue"]))
      ]),
      textTemplate: _withCtx(({ data: cellInfo }) => [
        _createVNode(_component_TextControl, {
          value: _ctx.getCellValue(cellInfo),
          onChanged: ($event: any) => (_ctx.onTemplateValueChanged($event, cellInfo)),
          key: _ctx.forceKeys[cellInfo.column.dataField],
          hasEmptyValue: _ctx.getColumnData(cellInfo.column.dataField).allowEmpty
        }, null, 8, ["value", "onChanged", "hasEmptyValue"])
      ]),
      "master-detail": _withCtx(({ data }) => [
        _createElementVNode("div", {
          id: `detailDomId_${data.data.id}_${_ctx.dxGridRenderKey}`,
          mounted: _ctx.onDetailMounted(data)
        }, null, 8, _hoisted_1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxColumnChooser, {
          height: null,
          width: null,
          enabled: _ctx.editingConfig.chooseColumns,
          mode: "select"
        }, null, 8, ["enabled"]),
        _createVNode(_component_DxFilterRow, {
          visible: _ctx.filterRowVisible,
          applyFilter: "onClick"
        }, null, 8, ["visible"]),
        _createVNode(_component_DxHeaderFilter, { visible: _ctx.headerFilterVisible }, null, 8, ["visible"]),
        _createVNode(_component_DxFilterPanel, { visible: _ctx.filterPanelVisible }, null, 8, ["visible"]),
        _createVNode(_component_DxFilterBuilderPopup, { position: _ctx.filterBuilderPopupPosition }, null, 8, ["position"]),
        _createVNode(_component_DxGroupPanel, { visible: false }),
        _createVNode(_component_DxGrouping, {
          "context-menu-enabled": _ctx.editingConfig.allowGrouping,
          "auto-expand-all": _ctx.designConfig.pagingMode == 'scroll'
        }, null, 8, ["context-menu-enabled", "auto-expand-all"]),
        (_ctx.designConfig.pagingMode == 'scroll')
          ? (_openBlock(), _createBlock(_component_DxScrolling, {
              key: 0,
              mode: "infinite"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_DxStateStoring, {
          enabled: true,
          type: "localStorage",
          "storage-key": _ctx.storageKey
        }, null, 8, ["storage-key"]),
        _createVNode(_component_DxExport, {
          enabled: _ctx.editingConfig.allowExportToExcel
        }, null, 8, ["enabled"]),
        _createVNode(_component_DxEditing, {
          "allow-updating": _ctx.editingConfig.allowUpdating,
          "allow-deleting": _ctx.editingConfig.allowDeleting,
          "confirm-delete": _ctx.editingConfig.confirmDelete,
          "allow-adding": _ctx.editingConfig.allowAdding,
          "use-icons": true,
          mode: _ctx.editingConfig.mode
        }, null, 8, ["allow-updating", "allow-deleting", "confirm-delete", "allow-adding", "mode"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
          return (_openBlock(), _createBlock(_component_DxColumn, {
            format: column.hideFraction ? `#,##0` : `#,##0.###`,
            alignment: column.alignment,
            "data-field": column.dataField,
            "data-type": column.dataType,
            caption: column.caption,
            key: column.dataField,
            "allow-editing": !column.readOnly,
            "validation-rules": column.validationRules,
            "edit-cell-template": column.editTemplateName,
            visible: column.visible,
            width: column.width,
            "min-width": column.minWidth,
            "css-class": column.cssClass,
            "calculate-display-value": _ctx.getColumnDisplayValueFunc(column),
            "display-field": column.displayField,
            allowFiltering: column.allowFiltering,
            allowSorting: column.allowSorting,
            allowGrouping: _ctx.editingConfig.allowGrouping,
            "sort-order": column.sortOrder ? column.sortOrder : null
          }, null, 8, ["format", "alignment", "data-field", "data-type", "caption", "allow-editing", "validation-rules", "edit-cell-template", "visible", "width", "min-width", "css-class", "calculate-display-value", "display-field", "allowFiltering", "allowSorting", "allowGrouping", "sort-order"]))
        }), 128)),
        (_ctx.editingConfig.mode == 'popup' && _ctx.editingConfig.allowUpdating)
          ? (_openBlock(), _createBlock(_component_DxColumn, {
              key: 1,
              buttons: _ctx.editButtons,
              type: "buttons",
              caption: "Действия",
              "show-in-column-chooser": false
            }, null, 8, ["buttons"]))
          : _createCommentVNode("", true),
        (_ctx.editingConfig.mode == 'row' && _ctx.editingConfig.allowCopy)
          ? (_openBlock(), _createBlock(_component_DxColumn, {
              key: 2,
              buttons: _ctx.editButtons,
              type: "buttons",
              caption: "",
              "show-in-column-chooser": false
            }, null, 8, ["buttons"]))
          : _createCommentVNode("", true),
        (_ctx.designConfig.pagingMode == 'paging')
          ? (_openBlock(), _createBlock(_component_DxPaging, {
              key: 3,
              "page-size": _ctx.pageSize
            }, null, 8, ["page-size"]))
          : _createCommentVNode("", true),
        (_ctx.designConfig.pagingMode == 'paging')
          ? (_openBlock(), _createBlock(_component_DxPager, {
              key: 4,
              "show-page-size-selector": _ctx.showPageSizeSelector,
              "allowed-page-sizes": _ctx.pageSizes,
              "show-info": true,
              visible: _ctx.dxPagerVisible
            }, null, 8, ["show-page-size-selector", "allowed-page-sizes", "visible"]))
          : _createCommentVNode("", true),
        _createVNode(_component_DxMasterDetail, {
          enabled: _ctx.editingConfig.enableMasterDetail,
          template: "master-detail"
        }, null, 8, ["enabled"])
      ]),
      _: 1
    }, 8, ["summary", "selection", "data-source", "column-auto-width", "allow-column-reordering", "remote-operations", "filter-builder", "filter-value", "onRowDblClick", "onContentReady", "onRowClick", "onInitNewRow", "onRowUpdating", "onRowUpdated", "onRowInserting", "onRowInserted", "onRowRemoved", "onRowPrepared", "onEditingStart", "onEditCanceling", "onSaving", "onOptionChanged", "onRowValidating", "onEditorPreparing", "onExporting", "onCellPrepared", "hover-state-enabled", "width", "height", "columnMinWidth", "onRowExpanding", "onSelectionChanged"]),
    (_ctx.popupCreateEditComponent)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.popupCreateEditComponent), {
          key: 0,
          saveModelCallback: _ctx.popupCreateEditSaveModelCallback,
          ref: "popupCreateEdit"
        }, null, 8, ["saveModelCallback"]))
      : _createCommentVNode("", true),
    (_ctx.popupInfoComponent)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.popupInfoComponent), {
          key: 1,
          ref: "popupInfo"
        }, null, 512))
      : _createCommentVNode("", true),
    (_ctx.editingConfig.allowDataFill)
      ? (_openBlock(), _createBlock(_component_DataFillDialog, {
          key: 2,
          ref: "dataFillDialog",
          columns: _ctx.getEditableColumns(),
          isLocalMode: false,
          controller: _ctx.controller,
          parentModel: _ctx.parentModel,
          dataGrid: _ctx.dxGrid,
          onOnDataFillApply: _ctx.onDataFillApply
        }, null, 8, ["columns", "controller", "parentModel", "dataGrid", "onOnDataFillApply"]))
      : _createCommentVNode("", true),
    (_ctx.editingConfig.allowImport)
      ? (_openBlock(), _createBlock(_component_ImportWorkflow, {
          key: 3,
          controller: _ctx.controller,
          importConfig: _ctx.importConfig,
          planId: this.parentModel?.id,
          onImportExportClose: _ctx.onImportClose,
          ref: "importWorkflow"
        }, null, 8, ["controller", "importConfig", "planId", "onImportExportClose"]))
      : _createCommentVNode("", true),
    (_ctx.editingConfig.allowExport)
      ? (_openBlock(), _createBlock(_component_ExportWorkflow, {
          key: 4,
          controller: _ctx.controller,
          exportConfig: _ctx.exportConfig,
          ref: "exportWorkflow"
        }, null, 8, ["controller", "exportConfig"]))
      : _createCommentVNode("", true),
    (_ctx.editingConfig.allowCopy)
      ? (_openBlock(), _createBlock(_component_CopyWorkflow, {
          key: 5,
          controller: _ctx.controller,
          ref: "copyWorkflow",
          onCopyProgressClose: _ctx.onCopyClose
        }, null, 8, ["controller", "onCopyProgressClose"]))
      : _createCommentVNode("", true)
  ], 544))
}